import React from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';

class PlaceholderTable extends React.Component {
    constructor(props) {
        super(props);
    }


    renderRows() {

        let rows = [];
        for (let i = 0; i < 10; i++) {
            rows.push(
                <tr key={i}>
                    <td scope="row" className="align-middle">
                        <div
                            className="placeholder placeholder__table-row placeholder--width-100 placeholder--fade-in"/>
                    </td>
                    <td className="align-middle">
                        <div
                            className="placeholder placeholder__table-row placeholder--width-100 placeholder--fade-in"/>
                    </td>
                    <td className="align-middle">
                        <div
                            className="placeholder placeholder__table-row placeholder--width-100 placeholder--fade-in"/>
                    </td>
                    <td className="align-middle">
                        <div className="placeholder placeholder__table-row placeholder--fade-in"/>
                    </td>
                    <td>
                        <div
                            className="placeholder placeholder__table-options-button placeholder--width-50 pull-right placeholder--fade-in"/>
                    </td>
                </tr>
            );
        }

        return rows;
    }

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="card m-b-20">
                        <div className="card-block">
                            <div className='row'>
                                {
                                    this.props.showButtons ? (
                                            <div className="col-sm-6">
                                                <div
                                                    className="placeholder placeholder__table-title placeholder--width-45  placeholder--fade-in"/>
                                            </div>
                                    ) : null
                                }{
                                this.props.showButtons ? (
                                        <div className="col-sm-6 pt-2 placeholder__table-button-container">
                                            <button
                                                className="btn btn-primary placeholder__table-button pull-right placeholder--fade-in">
                                                <div className="placeholder__table-button-text"/>
                                            </button>
                                        </div>
                                ) : null
                            }
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <MediaQuery query='(min-device-width: 768px)'>
                                            <th className="placeholder--width-5">
                                                <div
                                                    className="placeholder placeholder__table-heading placeholder--width-100 placeholder--fade-in"/>
                                            </th>
                                        </MediaQuery>
                                        <MediaQuery query='(max-device-width: 375px)'>
                                            <th>
                                                <div
                                                    className="placeholder placeholder__table-heading placeholder--width-100 placeholder--fade-in"/>
                                            </th>
                                        </MediaQuery>
                                        <th>
                                            <div
                                                className="placeholder placeholder__table-heading placeholder--fade-in"/>
                                        </th>
                                        <th>
                                            <div
                                                className="placeholder placeholder__table-heading placeholder--fade-in"/>
                                        </th>
                                        <th>
                                            <div
                                                className="placeholder placeholder__table-heading placeholder--fade-in"/>
                                        </th>
                                        <th>
                                            <div
                                                className="placeholder placeholder__table-heading placeholder--fade-in"/>
                                        </th>
                                    </tr>

                                    </thead>
                                    <tbody>
                                    {this.renderRows()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PlaceholderTable.defaultProps = {
    showButtons: true
};

export default PlaceholderTable;


// WEBPACK FOOTER //
// ./web/src/components/common/PlaceholderTable.jsx